<template>
  <v-container>
    <loading :active="isLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
      background-color="#ffffff" opacity="1" />

    <div v-show="!isLoading">
      <div v-if="loggedIn">
        <div class="d-flex align-self-center justify-space-between">
          <div class="name-content">
            <span>{{ accountName }}</span> 様
          </div>
          <v-btn @click="logout" rounded="xl" :disabled="doingLogout" variant="outlined" color="error" class="btn-logout">
            {{ logoutButtonLabel }}
          </v-btn>
        </div>

        <v-sheet color="primary-container" class="rounded-lg mt-5">
          <v-row no-gutters>
            <v-col class="pa-2">
              <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/account' } }"
                class="text-decoration-none">
                <v-icon>mdi-account</v-icon><br>
                <span>アカウント管理</span>
              </router-link>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col class="pa-2">
              <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/withdrawal/bank/setting' } }"
                class="text-decoration-none">
                <v-icon>mdi-credit-card</v-icon><br>
                <span>振込口座管理</span>
              </router-link>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col class="pa-2">
              <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/mailmag' } }"
                class="text-decoration-none">
                <v-icon>mdi-email-outline</v-icon><br>
                <span>メルマガ管理</span>
              </router-link>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="12" class="pa-4">
              <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/edit' } }"
                class="text-decoration-none">
                <v-icon>mdi-home-account</v-icon> 住所等のお客様情報管理
              </router-link>
            </v-col>
          </v-row>
        </v-sheet>

        <div v-if="notificate_contents.length > 0" class="mt-4">
          <h2 class="mb-2 text-error">
            <v-icon size="small" class="mr-1">mdi-alert</v-icon>ご確認ください
          </h2>
          <template v-for="content in notificate_contents" :key="content">
            <article-secondary class="article my-3" :content-title="content.title" :content-lead="content.lead"
              :content-desc="content.description" :content-uri="content.uri" :thumbnail-uri="content.thumbnail_url" :date-time="content.datetime" />
          </template>
        </div>

        <v-sheet color="surface-variant" class="mt-4 pa-1">
          <div class="list-menu">
            <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/fund/list' } }"
              class="d-flex justify-space-between text-decoration-none">
              <div class="align-self-center">
                出資ファンド一覧<br>
                <span>出資したファンドの確認</span>
              </div>
              <div class="align-self-center">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </router-link>
          </div>
          <div class="list-menu">
            <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/fund/portfolio' } }"
              class="d-flex justify-space-between text-decoration-none">
              <div class="align-self-center">
                出資レポート<br>
                <span>ファンドの運用成績の確認</span>
              </div>
              <div class="align-self-center">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </router-link>
          </div>
          <div class="list-menu">
            <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/ec/list' } }"
              class="d-flex justify-space-between text-decoration-none">
              <div class="align-self-center">
                ストア購入履歴<br>
                <span>ストアで購入した商品・明細の確認</span>
              </div>
              <div class="align-self-center">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </router-link>
          </div>
          <div class="list-menu">
            <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/withdrawal' } }"
              class="d-flex justify-space-between text-decoration-none">
              <div class="align-self-center">
                入出金履歴<br>
                <span>支払留保金の入金・出金・ご利用履歴の確認</span>
              </div>
              <div class="align-self-center">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </router-link>
          </div>
          <div class="list-menu">
            <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/mypage/news' } }"
              class="d-flex justify-space-between text-decoration-none">
              <div class="align-self-center">
                お知らせ一覧<br>
                <span>出資者限定ニュース等お知らせの確認</span>
              </div>
              <div class="align-self-center">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </router-link>
          </div>
          <div class="list-menu">
            <a class="d-flex justify-space-between" href="https://musicsecurities.zendesk.com/hc/ja">
              <div class="align-self-center">
                ヘルプ
              </div>
              <div class="align-self-center">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </a>
          </div>
          <div class="list-menu">
            <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/inquiry' } }"
              class="d-flex justify-space-between text-decoration-none">
              <div class="align-self-center">
                お問い合わせ
              </div>
              <div class="align-self-center">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </router-link>
          </div>
        </v-sheet>
      </div>
      <div v-else>
        <div class="d-flex justify-center my-4">
          <img src="/images/logo_300.png" width="120" />
        </div>
        <div class="login" style="margin: auto;">
          <LoginForm />
        </div>
        <div class="my-10">
          <SnsLogin />
        </div>
      </div>

      <h2 class="mt-4 mb-2">利用規約等</h2>
      <v-sheet color="surface-variant" class="pa-1">
        <div class="list-menu">
          <a class="d-flex justify-space-between" href="http://www.musicsecurities.com/company">
            <div class="align-self-center">
              運営会社
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </a>
        </div>
        <div class="list-menu">
          <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/terms' } }"
            class="d-flex justify-space-between text-decoration-none">
            <div class="align-self-center">
              利用規約
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </router-link>
        </div>
        <div class="list-menu">
          <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/privacy' } }"
            class="d-flex justify-space-between text-decoration-none">
            <div class="align-self-center">
              プライバシーポリシー
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </router-link>
        </div>
        <div class="list-menu">
          <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/security' } }"
            class="d-flex justify-space-between text-decoration-none">
            <div class="align-self-center">
              情報セキュリティ基本方針
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </router-link>
        </div>
        <div class="list-menu">
          <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/tokutei' } }"
            class="d-flex justify-space-between text-decoration-none">
            <div class="align-self-center">
              特定商取引法に基づく表記
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </router-link>
        </div>
        <div class="list-menu">
          <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/alcohol' } }"
            class="d-flex justify-space-between text-decoration-none">
            <div class="align-self-center">
              酒類販売管理者標識の掲示
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </router-link>
        </div>
        <div class="list-menu">
          <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/solicitation' } }"
            class="d-flex justify-space-between text-decoration-none">
            <div class="align-self-center">
              勧誘方針
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </router-link>
        </div>
        <div class="list-menu">
          <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/antisocial' } }"
            class="d-flex justify-space-between text-decoration-none">
            <div class="align-self-center">
              反社会的勢力に対する基本方針
            </div>
            <div class="align-self-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </router-link>
        </div>
      </v-sheet>

    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import LoginForm from '../components/LoginForm.vue'
import SnsLogin from '../components/SnsLogin.vue'
import Loading from 'vue3-loading-overlay';
import ArticleSecondary from "../components/ArticleSecondary.vue"

export default {
  name: 'AccountPage',
  components: {
    Loading,
    LoginForm,
    SnsLogin,
    ArticleSecondary
  },
  data: () => ({
    accountName: '',
    loggedIn: true,
    isLoading: true,
    doingLogout: false,
    logoutButtonLabel: 'ログアウト',
    notificate_contents: []
  }),
  mounted() {
    axios.get('/api/account/detail').then((response) => {
      this.loggedIn = true;
      this.accountName = response.data.account_name;
      this.notificate_contents = response.data.notificate_contents;
      this.$nextTick(() => {
        this.isLoading = false;
      });
    }).catch((error) => {
      this.loggedIn = false;
      console.log(error);
      this.$nextTick(() => {
        this.isLoading = false;
      });
    });

  },
  created: function () { },
  methods: {
    logout() {
      this.logoutButtonLabel = '処理中…';
      this.doingLogout = true;
      axios.post('/api/logout').then(() => {
        // SPAのルートに戻す
        location.href = '/progressive';
      });
    }
  }
}
</script>

<style scoped>
a {
  color: #000 !important;
  text-decoration: none !important;
}

.btn-logout {
  margin-left: 8px;
  align-self: center;
  width: 110px;
}

.name-content {
  align-self: center;
}

.name-content span {
  color: #0168b7;
  font-weight: 700;
  font-size: 1.3em;
}

.v-col {
  text-align: center;
}

.v-col span {
  font-size: 12px;
}

.list-menu {
  padding: 10px;
  margin-bottom: 4px;
  background-color: #fff;
}

.list-menu span {
  font-size: 12px;
}

.list-menu:last-child {
  margin-bottom: 0;
}

.mdi-chevron-right {
  color: #999;
}
</style>